module.exports = __webpack_public_path__ + "img/google-plus.f171f2eb.png";